import BaseService from "src/packages/BaseService";

export default class TrackService extends BaseService {
	static get className() {
		return "tracks";
	}

	// TODO: change to admin route
	static async fetchTracks(projectId) {
		return BaseService.getService()
			.get(`/tracks/${projectId}`)
			.then(response => {
				return response.data;
			});
	}
}
